import { storyblokEditable } from '@storyblok/react/rsc';
import { FC } from 'react';
import { ButtonCtaStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { renderLink } from 'atoms/StoryBlokLink';
import { isValidDate } from 'modules/stroyblok/services';
import styles from './styles.module.css';

export const ButtonCTA: FC<{
  blok: ButtonCtaStoryblok;
}> = ({ blok }) => {
  const isDateValid = isValidDate(blok.startDate, blok.expirationDate);

  return !isDateValid ? null : (
    <div className={styles.buttonWrapper} {...storyblokEditable(blok)}>
      <Button
        href={renderLink(blok.link)}
        style={{ background: blok.color.color }}
      >
        {blok.title}
      </Button>
    </div>
  );
};
